<div class="breadcrumb-container">
  <ul class="reset">
    @for (breadCrumb of breadCrumbs; track breadCrumb; let last = $last) {
      <li>
        <button class="link" [ngClass]="{'active': last}" [disabled]="!breadCrumb.clickable" (click)="onBreadCrumbClick(breadCrumb)">{{breadCrumb.label}}</button>
        @if (!last) {
          <div class="triangle"></div>
        }
      </li>
    }
  </ul>
</div>
